"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFormFieldEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const CustomFormFieldDto_1 = require("./CustomFormFieldDto");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const INDEX_NOT_FOUND = -1;
class CustomFormFieldEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, customFormField) {
        super();
        this._requiredFieldsSetStatus = {
            customFormId: false,
            fieldLabel: false,
            responseType: false
        };
        this._dependencies = dependencies;
        if (customFormField === undefined) {
            this._dto = new CustomFormFieldDto_1.CustomFormFieldDto();
        }
        else if (customFormField instanceof CustomFormFieldDto_1.CustomFormFieldDto) {
            this._dto = new CustomFormFieldDto_1.CustomFormFieldDto(customFormField);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (customFormField instanceof CustomFormFieldEntity) {
            this._dto = new CustomFormFieldDto_1.CustomFormFieldDto(customFormField._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new CustomFormFieldDto_1.CustomFormFieldDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getCustomFormId() {
        return this._dto.customFormId;
    }
    setCustomFormId(untrustedValue) {
        let _untrustedValue;
        this.clearError("customFormId");
        this._requiredFieldsSetStatus.customFormId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("customFormId", "Custom Form Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("customFormId", "Custom Form is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.customFormId) {
            return;
        }
        this._dto.customFormId = _untrustedValue;
        this._setIsDirty(true);
    }
    getFieldLabel() {
        return this._dto.fieldLabel;
    }
    setFieldLabel(untrustedValue) {
        const maxLength = 60;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("fieldLabel");
        this._requiredFieldsSetStatus.fieldLabel = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("fieldLabel", "Field Label is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("fieldLabel", `Field Label has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.fieldLabel) {
            return;
        }
        this._dto.fieldLabel = _untrustedValue;
        this._setIsDirty(true);
    }
    getResponseType() {
        return this._dto.responseType;
    }
    setResponseType(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("responseType");
        this._requiredFieldsSetStatus.responseType = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("responseType", "Response Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("responseType", `Response Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.responseType) {
            return;
        }
        this._dto.responseType = _untrustedValue;
        this._setIsDirty(true);
    }
    getIsRequired() {
        return this._dto.isRequired;
    }
    setIsRequired(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("isRequired", "Is Required is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("isRequired", "Is Required is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue === this._dto.isRequired) {
            return;
        }
        this.clearError("isRequired");
        this._dto.isRequired = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.customFormFieldDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Custom Form Fields is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.customFormFieldDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.customFormFieldDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Custom Form Field cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.customFormFieldDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.CustomFormFieldEntity = CustomFormFieldEntity;
//# sourceMappingURL=CustomFormFieldEntity.js.map